<ion-card>
  <ion-card-content>
    <ion-img src="assets/img/bancontact-logo.png"></ion-img>
    <p class="title">Bancontact Terminal</p>
    <p class="content">Neem een bancontact terminal mee.</p>
    <div class="actions">
      <ion-button expand="block" (click)="close()" color="primary">Bevestigen</ion-button>
    </div>
  </ion-card-content>
</ion-card>